module.exports = __webpack_public_path__ + "img/pcStudio.5a3e66b8.jpg";